import request from '@/utils/request'

// 获取用户详细信息
export const getCusInfo = params =>
  request.get(`/customer-api/customer/workflow/query/${params.id}`)
// 信用审批详情 ---> Current Credit Line字段 http://10.103.250.80:3001/project/47/interface/api/13826
export const getCssDetail = params =>
  request.get(`/workflow-api/credit-css/approve/detail/${params.bpmId}`)
// 保存
export const saveAudit = params =>
  request.post(`/workflow-api/credit-apply/approve/save`, params, {
    timeout: 300000,
  })
// 更新
export const updateAudit = params =>
  request.post(`/workflow-api/credit-apply/approve`, params)
// 派发
export const resignAudit = params =>
  request.post(`/workflow-api/work-queue/assign`, params)
// 下载文件
export const getFile = params =>
  request.get(
    `/workflow-api/credit-apply/attachment/download/${params.id}`,
    {},
    { responseType: 'blob' },
  )
// 删除文件
export const removeFile = params =>
  request.get(`/workflow-api/credit-apply/attachment/delete/${params.id}`)

// addition conditions 下拉列表数据
export const getOptions = params => {
  request.post('/masterdata-api/valuelist/getValueList', params)
}
// css - 审批提交 update decision
export const cssAudit = params =>
  request.post('/workflow-api/credit-css/approve', params)
// css -update 已经完成的update
export const getCompletedUpdate = params => {
  request.post('/workflow-api/credit-css/approve/update', params)
}

// resubmit 二次审核提交
export const secondSubmit = params => {
  request.post('/workflow-api/credit-css/approve/resubmit', params)
}
// 二次审核拒绝
export const secondDeclined = params => {
  request.get(`/workflow-api/credit-css/reject/${params.bpmId}`)
}
// 新增用户查看客户日志
export const getAddlog = params =>
  request.post('/customer-api/company-search-logs/add', params)
// css审批保存 Save
export const finalAuditSave = params => {
  request.post('/workflow-api/credit-css/approve/save', params)
}

export const vagueQuery = params =>
  request.get(`/customer-api/customer/list/${params.name}`)

// 查询active name
export const vagueActiveName = params =>
  request.get(`/masterdata-api/user/active/query/${params.name}`)
